import { generate_guid } from '@/rlMxModules/utils/util'

class rlWallModelSectData {
  constructor(Name = null, Mat = null, Kind = null, B = null, H = null, Guid = null) {
    // this.ID = ID  // 数据库ID
    this.Name = Name //截面名称
    this.Mat = Mat //材质
    this.Kind = Kind //截面类型
    this.B = B //墙厚
    this.H = H;
    this.Guid = Guid ? Guid : generate_guid()
  }
}

export default rlWallModelSectData
